import React from 'react';
import { Box, Card, CardContent, CardHeader, Divider } from '@mui/material';

import TrendChart from './TrendChart';

export default function FinancialReportTrendCard({ chartSeries, chartWidth }) {
    return (
        <Card>
            <CardHeader title="Verlauf" />
            <Divider />
            <CardContent>
                <Box sx={{ width: '100%', overflowX: 'auto' }}>
                    <TrendChart series={chartSeries} width={chartWidth} />
                </Box>
            </CardContent>
        </Card>
    );
}
